<template>
  <div class="flex">
      <AdminPanel>
        <h1 class="mb-4">Garment Color Pricing</h1>
        <div>
          <div class="mx-4 flex flex-col">
            <h2>Light Garments</h2>
            <div class="flex flex-col">
              <div :key="key" v-for="key in Object.keys(tiers.light)" class="flex justify-center items-center">
                <div class="mr-2">
                  {{ key }}
                </div>
                <div>
                  <MoneyInput ref="light" :tier="key" :initValue="tiers.light[key]"></MoneyInput>
                </div>
              </div>
            </div>
            <h2 class="mt-4">Dark Garments</h2>
            <div class="flex flex-col">
              <div :key="key" v-for="key in Object.keys(tiers.dark)" class="flex justify-center items-center">
                <div class="mr-2">
                  {{ key }}
                </div>
                <div>
                  <MoneyInput ref="dark" :tier="key" :initValue="tiers.dark[key]"></MoneyInput>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-4" @click="save">
            <JButton :label="saveText" :isWhite="false"></JButton>
          </div>
        </div>
      </AdminPanel>
    </div>
</template>

<script>
import JButton from '@/components/JButton'
import AdminPanel from '@/components/AdminPanel'
import MoneyInput from '@/components/MoneyInput'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'ChangeGarmentColorPricing',
  components: { AdminPanel, MoneyInput, JButton },
  data () {
    return {
      saveText: 'Save',
      tiers: {
        light: [],
        dark: []
      }
    }
  },
  async mounted () {
    this.tiers.light = await this.getGarmentPricing('light')
    this.tiers.dark = await this.getGarmentPricing('dark')
  },
  methods: {
    async getGarmentPricing (shade) {
      if (this.tiers[shade].length === 0) {
        const pricing = (await firebase.firestore().doc(`pricing/${shade}Garments`).get()).data()
        return pricing
      }

      return this.tiers[shade]
    },
    async save () {
      this.saveText = 'Saving...'
      for (let lightInput of this.$refs.light) {
        await this.saveGarmentColor('light', lightInput.getTier(), lightInput.getValue())
      }

      for (let darkInput of this.$refs.dark) {
        await this.saveGarmentColor('dark', darkInput.getTier(), darkInput.getValue())
      }
      this.saveText = 'Saved!'
    },
    saveGarmentColor (shade, tier, value) {
      const valueObject = {}
      valueObject[tier] = value
      return firebase.firestore().doc(`pricing/${shade}Garments`).update(valueObject)
    }
  }
}
</script>
